const CTASection = ({ onOpenWaitlist }) => {
  return (
    <section id="cta" className="bg-[#f8f9fa] border-t border-[#e8eaed]" data-testid="cta-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-8 py-16 sm:py-20 lg:py-24">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-[28px] sm:text-[34px] lg:text-[40px] font-normal text-[#202124] leading-tight" data-testid="cta-title">
            Let's start building your tomorrow, today
          </h2>
          <p className="mt-4 text-[15px] sm:text-base text-[#5f6368] leading-relaxed max-w-lg mx-auto">
            Get started with Helocore for free. No credit card required.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <button
              onClick={onOpenWaitlist}
              className="inline-flex items-center px-6 py-3 bg-[#6C5CE7] hover:bg-[#e8872e] text-white text-[14px] font-medium rounded-md transition-colors shadow-sm"
              data-testid="cta-get-started"
            >
              Join waitlist
            </button>
            <button
              onClick={onOpenWaitlist}
              className="inline-flex items-center px-6 py-3 border border-[#dadce0] hover:bg-white text-[14px] font-medium text-[#6C5CE7] rounded-md transition-colors"
              data-testid="cta-contact"
            >
              Contact us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
